import { z } from 'zod'

const DEFAULT_AUFTRAG_X_25 = {
  enabled: false
}

export const AuftragX_25Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_X_25.enabled)
  })
  .default(DEFAULT_AUFTRAG_X_25)

export type AuftragX_25Data = z.infer<typeof AuftragX_25Schema>
